import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import ProtectedRoute from './components/ProtectedRoute'
import Sidebar from './components/Sidebar'
import Topbar from './components/Topbar'
import ThemeProvider from './components/ThemeProvider'
import Dashboard from './pages/Dashboard'
import ContractList from './pages/ContractList'
import ContractEditor from './pages/ContractEditor'
import ContractViewer from './pages/ContractViewer'
import TemplateList from './pages/TemplateList'
import TemplateEditor from './pages/TemplateEditor'
import ContractTypes from './pages/ContractTypes'
import CompanySettings from './pages/CompanySettings'
import AdminGlobal from './pages/AdminGlobal'
import Login from './pages/Login'

export default function App() {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center vh-100 bg-dark">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    )
  }

  return (
    <ThemeProvider>
      <div className="app-layout">
        <Sidebar />
        <div className="a-main">
          <Topbar />
          <div className="a-content">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/contracts" element={<ProtectedRoute><ContractList /></ProtectedRoute>} />
              <Route path="/contracts/new" element={<ProtectedRoute><ContractEditor /></ProtectedRoute>} />
              <Route path="/contracts/:id" element={<ProtectedRoute><ContractViewer /></ProtectedRoute>} />
              <Route path="/contracts/:id/edit" element={<ProtectedRoute><ContractEditor /></ProtectedRoute>} />
              <Route path="/templates" element={<ProtectedRoute><TemplateList /></ProtectedRoute>} />
              <Route path="/templates/new" element={<ProtectedRoute><TemplateEditor /></ProtectedRoute>} />
              <Route path="/templates/:id/edit" element={<ProtectedRoute><TemplateEditor /></ProtectedRoute>} />
              <Route path="/contract-types" element={<ProtectedRoute><ContractTypes /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><CompanySettings /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute requireSuperadmin><AdminGlobal /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </ThemeProvider>
  )
}
